export default __webpack_public_path__ + "static/media/select-arrow-open.0546c934.svg";